import { render, staticRenderFns } from "./PolymorphicReferenceUpdate.vue?vue&type=template&id=e83c97fa&"
import script from "./PolymorphicReferenceUpdate.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PolymorphicReferenceUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports